import { useContext } from 'react'
import { PopupMessageContext } from 'src/contexts'

export const useCurrentPopupMessage = () => {
  const { message, onClose } = useContext(PopupMessageContext)
  return { message, onClose }
}
